import { TreeDataNode } from 'antd';

export const collectKeys = (nodes: TreeDataNode[]): string[] =>
  nodes.reduce<string[]>((acc, node) => {
    if (node.key !== 'all') acc.push(String(node.key));
    if (node.children) acc.push(...collectKeys(node.children));
    return acc;
  }, []);
